import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "cookies-link",
    tabindex: "-1",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCookieSettings && _ctx.openCookieSettings(...args)))
  }, _toDisplayString(_ctx.$t(`Disclaimer.oneTrustCookie`)), 1))
}